import { graphql } from '../../../graphql/generated';

export const REQUEST_QUERY = graphql(`
  query Request($id: ID!, $doctorId: ID!) {
    request(id: $id) {
      id
      createdAt
      modifiedAt
      sentAt
      sampledAt
      status
      insuranceShortName
      insuranceName
      importType
      importRequestId
      additionalData
      comment
      aisVendor
      aisVendorName
      aisRequestId
      aisSub
      orders {
        id
        number
        diagnose
        labInfo
        acute
        elgaOptOut
        type
        createdAt
        createdByFirstName
        createdByLastName
        receivedAt
        invoiceNumber
        invoiceCancellationNumber
        aisExportedAt
        lastLocalExport
        orderLabels {
          id
          text
          text2
          number
          name
          classification
          color
          features
          printedAt
          location
          localizationFieldValues {
            label
            unit
            value
            inputType
          }
          paramShortNames
          specimenId
          testTubeId
          runningNumber
          specialPrinterRequired
          analysisStationNames
        }
        orderParameters {
          id
          shortName
          longName
          diagnose
          billingType
          specialRateCode
          specialRateShortName
          price
          acute
        }
        orderFiles {
          id
          printedAt
          name
          type
          fileName
          size
          printRequired
          printable
          pickup
        }
        orderForms {
          id
          header
          fields {
            id
            values
            label
            type
          }
        }
        lab {
          id
          name
        }
      }
      patientData {
        externalId
        title
        firstName
        lastName
        birthday
        gender
        svnr
        insuranceCategory
        insuranceCode
        street
        zip
        city
        country
        phone
        email
        idCardType
        idCardNumber
        idCardAuthority
        insuredPerson {
          title
          firstName
          lastName
          birthday
          gender
          svnr
          street
          zip
          city
          country
          phone
          email
        }
      }
      createdByLastName
      createdByFirstName
      modifiedByLastName
      modifiedByFirstName
      sentByFirstName
      sentByLastName
    }

    doctor(id: $doctorId) {
      id
      flipParamNames
      showPrices
      zplLabelTemplate
    }
  }
`);
